export default function orMinus(text: string | null) {
  if (
    text === undefined ||
    text === null ||
    text === ''
  ) return '-';
  return text;
}
